import React from 'react';
import Modal from 'react-modal/lib/components/Modal';
import Styles from './AdminDialog.module.css';
import DefaultButton from '../forms/DefaultButton';
import GenericDialog from '../GenericDialog/GenericDialog'
const AdminDialog = (
  {
    isOpen,
    onRequestClose,
    afterClose,
    data,
    dataId,
    title,
    method,
    type
  }) => {
  const [genericDialog, setGenericDialog] = React.useState(false)
  const [dialogData, setDialogData] = React.useState([''])
  function handleCloseDialog() {
    setGenericDialog(false)
  }
  function openGenericDialog() {
    setGenericDialog(true)
  }
  const methodHandler = () => {
    let promise
    switch (type) {
      case 'update':
        promise = Promise.resolve(
          method(dataId, data)
        )
        break;
      case 'add':
        promise = Promise.resolve(
          method(data)
        )
        break;
      case 'remove':
        console.warn(data)
        promise = Promise.resolve(
          method(data)
        )
        break;
    }
    promise.then((e) => {
      setDialogData(e)
      openGenericDialog()
      onRequestClose()
      setTimeout(() => {
        afterClose ? afterClose() : undefined
      }, 200);
    })
  }

  return (
    <div className="AdminDialog">
      <Modal
        isOpen={isOpen}
        ariaHideApp={false}
        contentLabel="Selected Option"
        overlayClassName="react-modal-overlay"
        className="react-modal-content"
        onRequestClose={onRequestClose}
      >
        {" "}
        <button
          className="react-modal-close"
          type="button"
          onClick={onRequestClose}
        >
          <span>&#x2715;</span>
        </button>
        <div className={Styles.contentModal}>
          <h2>{title}</h2>
          <div className={Styles.list}>
            <ul>
              <li>Email: <b>{data.email ? data.email.toUpperCase() : ''}</b></li>
              <li>Permissão: <b>{data.permission ? data.permission.toUpperCase() : ''}</b></li>
              <li>Web Notification: <b>{data.modules?.web_push ? data.modules?.web_push.toUpperCase() : ''}</b></li>
              <li>Oferta Contextual: <b>{data.modules?.oferta_contextual ? data.modules?.oferta_contextual.toUpperCase() : ''}</b></li>
              {/*<li>Vitrine de Componentes: <b>{data.modules?.vitrine ? data.modules?.vitrine.toUpperCase() : ''}</b></li>*/}
              <li>Dashboards: <b>{data.modules?.dashboards ? data.modules?.dashboards.toUpperCase() : ''}</b></li>
            </ul>

          </div>
          <div className={Styles.contentModalBtn}>
            <DefaultButton
              type={`red`}
              size="MD"
              onClick={() => methodHandler()}
              children="Sim"
            />
            <DefaultButton
              type={`red`}
              size="MD"
              onClick={onRequestClose}
              children="Não"
            />
          </div>
        </div>
      </Modal>
      <GenericDialog
        isOpen={genericDialog}
        onRequestClose={handleCloseDialog}
        data={dialogData}
      />
    </div>

  )
}
AdminDialog.propTypes = {};
AdminDialog.defaultProps = {};

export default AdminDialog;
